
const c_FeatureCodes = {
    AI_COACH_REVIEW: 'AI_COACH_REVIEW',
};

// How a stored billing interval reads to a person. The values themselves are the gateway's
// vocabulary and are never put in front of anyone.
const c_BillingIntervalLabels = {
    month: 'Monthly',
    year: 'Annual',
};

const get_billing_interval_label = (billing_interval) => {
    if(billing_interval && c_BillingIntervalLabels[billing_interval]) {
        return c_BillingIntervalLabels[billing_interval];
    }

    return '';
};

const Constants =
{
    SERVER_URL: "https://app.aicalltrainer.com",
    // SERVER_URL: "https://dev.aicalltrainer.com",
    // SERVER_URL: "http://192.168.0.2:8732",
    TOKEN_NAME: "aicalltrainer-token",
    USER_EMAIL: 'aicalltrainer-user-email',
    USER_ID: 'aicalltrainer-user-id',
    SIGNUP_USER_EMAIL: 'signup-user-email',
    SIGNUP_SELECTED_PLAN: 'signup-selected-plan',
    DEFAULT_VOICE_MODE: 'aicalltrainer-default-voice',
    HARNESS_MODE: 'aicalltrainer-harness-mode',
    HARNESS_TURNS: 'aicalltrainer-harness-turns',
    c_FeatureCodes,
    // A plan's billing_interval is stored as 'month' or 'year'. Neither word is ever shown to a
    // reader: this is what they see instead.
    get_billing_interval_label,
};

module.exports = Constants;
